<script lang="ts">
    import { scale } from "svelte/transition"
    import { mdiClose } from "@mdi/js"
    import Icon from "./Icon.svelte"

    export let showCloseIcon: boolean = true
    export let show: boolean = false
    export let size: string = "md"
    export let cssClass: string = ""

    const clickOnBackground = () => {
        show = false
    }
</script>

<div role="button" tabindex="0" class="modal-wrapper {cssClass}" class:show on:click="{clickOnBackground}" on:keydown>
    <div
        role="button"
        tabindex="0"
        class="modal modal-{size}"
        transition:scale
        on:click|stopPropagation="{() => {}}"
        on:keydown
    >
        {#if $$slots.close || showCloseIcon}
            <div
                class="modal-close"
                role="button"
                tabindex="0"
                on:click="{() => {
                    show = false
                }}"
                on:keydown
            >
                {#if showCloseIcon}
                    <Icon path="{mdiClose}" size="24px" />
                {/if}
                <slot name="close" />
            </div>
        {/if}
        {#if $$slots.header}
            <div class="modal-header">
                <slot name="header" />
            </div>
        {/if}
        {#if $$slots.default}
            <div class="modal-content">
                <slot />
            </div>
        {/if}
        {#if $$slots.footer}
            <div class="modal-footer">
                <slot name="footer" />
            </div>
        {/if}
    </div>
</div>
